export default {
    methods: {
        /**
         * Checks if a field is present.
         *
         * @param {Object} field - The field object to check.
         * @returns {boolean} - True if the field is defined, false otherwise.
         */
        getField(field) {
            return field !== undefined;
        },

        /**
         * Retrieves a subfield from a given field.
         *
         * @param {Object} field - The parent field object.
         * @param {string} subField - The name of the subfield to retrieve.
         * @returns {*} - The subfield value or undefined if not found.
         */
        getSubField(field, subField) {
            if (field !== undefined && field.SUBFLD !== undefined) {
                const f = field.SUBFLD[0][subField];
                return f !== undefined ? f : undefined;
            } else {
                return undefined;
            }
        },

        /**
         * Returns the label for a given field.
         *
         * @param {Object} field - The field object.
         * @returns {string} - The label (field.NAME) or an empty string.
         */
        getLabel(field) {
            return field && field.NAME || "";
        },

        /**
         * Extracts and formats options from a field object.
         *
         * @param {Object} field - The field object.
         * @returns {Array<{text: string, value: string}>} - Array of option objects.
         */
        getOptions(field) {
            if (field && field.OPTIONS) {
                return Object.entries(field.OPTIONS).map(([value, text]) => ({ text, value }));
            } else {
                return [];
            }
        },



        /**
         * Returns options for a RC field, same as getOptions().
         *
         * @param {Object} field - The field object.
         * @returns {Array<{text: string, value: string}>} - Array of option objects.
         */
        getRCOptions(field) {
            if (!field || !field.OPTIONS) {
                return [];
            }

            const keys = Object.keys(field.OPTIONS);
            const out = [];

            for (const k of keys) {
                const item = field.OPTIONS[k];

                out.push({
                    value: k,
                    text: item.TEXT || "",
                    help: item.HELPTXT || ""
                });
            }
            /*   out.push({
                     value: "",
                     text: "",
                     help: ""
                 }); */

            return out;
        },

        /**
         * Returns an array of validation rules for the given field.
         *
         * @param {Object} field - The field object containing type and validation metadata.
         * @returns {Array<Function>} - Array of validation rule functions.
         */
        getValidators(field) {
            const rules = [];
            if (!field) return rules;

            if (field) {
                // 1. Pflichtfeld-Check
                if (field.MANDATORY !== undefined && field.MANDATORY === true) {
                    rules.push(value => {
                        return !!value || this.t('common', 'STR_REQUIRED');
                    });
                }

               /*  if (field.PATTERN) {
                    const patternStr = field.PATTERN;

                    rules.push(value => {
                        if (!value) return true;

                        try {
                            // 1. "Säubern" des Strings
                            const cleanPattern = patternStr.replace(/^\/|\/$/g, '');

                            // 2. Anker setzen! 
                            // Ohne ^ (Start) und $ (Ende) prüft Regex nur, ob IRGENDWO im Text 
                            // ein gültiges Zeichen ist. Wir wollen aber, dass der GESAMTE Text passt.
                            const anchoredPattern = cleanPattern.startsWith('^')
                                ? cleanPattern
                                : `^${cleanPattern}$`;

                            // 3. Das Unicode-Flag 'u' ist entscheidend für Hex-Codes (\x21)
                            const regex = new RegExp(anchoredPattern, 'u');

                            return regex.test(value) || this.t('common', 'STR_INVALID_FORMAT');
                        } catch (e) {
                            console.error("Regex Fehler:", e);
                            return true;
                        }
                    });
                } */

                // 3. Typ-Prüfungen (Numerisch, Email, etc.)
                if (field.TYPE === "ND") {
                    rules.push(value => {
                        if (value !== "" && value !== undefined && value !== null) {
                            return !isNaN(parseFloat(value)) || this.t('common', 'STR_NUMERICWITHSEPERATOR');
                        }
                        return true;
                    });
                }

                if (field.TYPE === "N") {
                    rules.push(value => {
                        if (value !== "" && value !== undefined && value !== null) {
                            return !isNaN(parseInt(value)) || this.t('common', 'STR_NUMERIC');
                        }
                        return true;
                    });
                }

                if (field.TYPE === "E") {
                    rules.push(value => {
                        if (!value) return true;
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || 'Invalid e-mail.';
                    });
                }
            }

            return rules;
        }
    },
};
